export const MapHighlightedAreaTypes = /** @type {const} */ ({
    SEARCH: 'search',
    INTEREST: 'interest',
});

export const MapSpotFilterTypes = /** @type {const} */ ({
    SPOTS: 'spots',
    TIPS: 'tips',
});
